import { Dataset } from '../types/types';

// Drop a dataset that resolved for a subset the user already left (stale useDataset latestIdRef on the cached-tab path).
export const shouldApplyFetchedDataset = (
  fetchedDataset: Dataset | undefined,
  subsetId: string | null
): subsetId is string =>
  Boolean(fetchedDataset && subsetId && fetchedDataset.datasetId === subsetId);
